import { FETCH_JOKL_CREDITS, CLEAN_JOKL_CREDITS } from '../actions/types';

const JOKL_CREDITS_DEFAULT_STATE = {};

const JoklCreditsReducer = (state = JOKL_CREDITS_DEFAULT_STATE, { type, payload }) => {
    switch (type) {
        case FETCH_JOKL_CREDITS:
            return payload;

        case CLEAN_JOKL_CREDITS:
            return JOKL_CREDITS_DEFAULT_STATE;

        default:
            return state;
    }
};

export default JoklCreditsReducer;
